import { z } from 'zod'

const envSchema = z.object({
  VITE_AUTH0_DOMAIN: z.string().min(1),
  VITE_AUTH0_CLIENT_ID: z.string().min(1),
  VITE_AUTH0_AUDIENCE: z.string().url(),
  VITE_AUTH0_NAMESPACE: z.string().url(),
  VITE_API_BASE_URL: z.string().url(),
})

const result = envSchema.safeParse(import.meta.env)
if (!result.success) {
  throw new Error('Invalid env: ' + JSON.stringify(result.error.flatten().fieldErrors))
}

export const env = result.data
